import React from "react"
import AIModalJson from "../../Configs/JSON/AIModal.json"
import "../../styles/calculator/AnnualIncomeModal.less"
import GenericModal from "../Common/GenericModal"
import CircleIcon from "../Common/CircleIcon"
import { observer } from "mobx-react"
import AppStore from "../../Configs/Store/index"
import FormStore from "../../Configs/Store/forms"

const AI_Modal = observer(() => {
  return (
    <>
      <GenericModal
        visibleState={FormStore.calc_aiModal}
        updateVisibility={() => FormStore.setAIModal(false)}
        closeIcon={<CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />}
        rootClassAntCustom={"AnnualIncomeModal"}
        showButton={true}
        buttonText={AIModalJson["buttonText"]}
        // buttonStyle={"OKButton"}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={() => FormStore.setAIModal(false)}
        component={
          <div className="contentWrap">
            <CircleIcon iconStyle="titleICon" iconUrl={AIModalJson["mainIcon"]} imgwidth={AIModalJson["imgwidth"]} imgheight={AIModalJson["imgheight"]} imgalt={AIModalJson["imgalt"]} />
            <div className="SectionTitle">{AIModalJson["modalTitle"]}</div>
            <div className="content">{AIModalJson["modalContent"]}</div>
          </div>
        }
      />
    </>
  )
})

export default AI_Modal
